import React from "react";

const MAP = {
  pending: { c: "#2563EB", label: "Pending" },
  processing: { c: "#D97706", label: "Processing" },
  approved: { c: "#059669", label: "Approved" },
  paid: { c: "#059669", label: "Paid" },
  rejected: { c: "#DC2626", label: "Rejected" },
};

export const StatusBadge = ({ status }) => {
  const s = MAP[status] || { c: "#71717A", label: status };
  return (
    <span
      data-testid={`status-badge-${status}`}
      className="inline-flex items-center rounded-full px-2.5 py-0.5 text-[11px] font-semibold uppercase tracking-wider"
      style={{ color: s.c, backgroundColor: `${s.c}1a` }}
    >
      {s.label}
    </span>
  );
};
